import {
  getOwnerMember,
  getMemberCounty,
  getMemberEmail,
  getMemberZipCode
} from './memberUtils'
import { sortPlansByRank } from './planUtils'
import { serializeMembers, formatDate } from './serializers/memberSerializers'
import { getRouteByStepDone, isOEP } from 'utils/generalUtils'
import { ROUTE_STEP } from 'consts/flowConsts'

export const deserializePlanByRank = ({ plans, rankToSortBy = 'low' }) => {
  // we need to sort the plans by the rank selected,
  // if no rank is selected, we default to low
  const sortedPlans = sortPlansByRank(plans, rankToSortBy)

  // Mark the first 3 items as recommended
  sortedPlans.slice(0, 3).forEach(plan => {
    plan.isRecommended = true
  })

  return sortedPlans
}

export const serializeInitApplication = state => {
  const ownerMember = getOwnerMember(state.member.members)
  const countyNameOnly = getMemberCounty(ownerMember).split(' ')[0]
  const data = {
    zip_code: getMemberZipCode(ownerMember),
    county: countyNameOnly,
    email: getMemberEmail(ownerMember) || null
  }
  return data
}

const calcStepToSave = (state, step, skipNavigation) => {
  // in case skip navigation we should save the current step
  // else we would send the next step to the server
  let stepToSave
  if (skipNavigation) {
    stepToSave = step
  } else {
    stepToSave =
      ROUTE_STEP[
        getRouteByStepDone({
          step,
          isOEP: isOEP(state.app?.appConfig)
        })
      ]
  }
  return stepToSave
}

export const serializeSaveProgress = ([
  {
    ccEmail,
    step,
    saveProgressEmailRequested,
    skipNavigation = false,
    ...more
  },
  state
]) => {
  const memberQualifyLifeEvent = state.member.memberQualifyLifeEvent
  const enrollment_reason = {
    reason: memberQualifyLifeEvent.reason,
    qualifying_life_event_date: formatDate(memberQualifyLifeEvent.date)
  }
  const applicationId = state.application.applicationId
  const savedPlans = state.plan.savedPlans
  const selectedPlanId = state.plan.selectedPlan?.antidote_plan_id
  const members = serializeMembers(state.member.members)
  const isConsentSigned = state.application.isConsentSigned
  const coveragesStartDate = formatDate(
    state.member?.memberQualifyLifeEvent?.coverageStartDate
  )
  const saveProgressEmailRequestedBool = !!saveProgressEmailRequested
  const stepToSave = calcStepToSave(state, step, skipNavigation)
  const enrollmentPeriod = isOEP(state.app?.appConfig) ? 'oep' : 'sep'

  const serializedData = {
    antidote_plan_id: selectedPlanId,
    rank: state.plan?.planRank,
    enrollment_period: enrollmentPeriod,
    favorite_plans: savedPlans?.map(plan => plan.id),
    cc_email: ccEmail,
    coverage_start_date: coveragesStartDate,
    application_id: applicationId,
    enrollment_reason: enrollment_reason,
    enrollees: members,
    is_consent_signed: isConsentSigned,
    save_progress_email_requested: saveProgressEmailRequestedBool,
    step: stepToSave
  }
  return { serializedData, step, skipNavigation, ...more }
}

export const deserializerZipCodeRes = data => {
  const countyList = data?.map(curr => ({
    value: curr?.county?.county_name,
    label: curr?.county?.county_name
  })) // Using map to directly extract county names into an array

  return {
    zipCode: data?.[0]?.zip_code, // Accessing the zip_code property of the first element in data, if it exists
    countyList,
    selectedCounty: data?.countyList?.[0]?.value
      ? data?.countyList?.length === 1
      : null
  }
}
